<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Header :showGoBack="true" />

    <main
      class="scrollable container"
      :style="{paddingTop: '10px', paddingBottom: '20px'}"
    >
      <span
        :style="{
          textAlign: 'center',
          display: 'block',
          fontSize: '40px',
          marginBottom: '10px',
        }"
        >- 263.57 USD</span
      >
      <span
        class="t14"
        :style="{textAlign: 'center', display: 'block', marginBottom: '20px'}"
        >Apr 10, 2023 at 11:34 AM</span
      >
      <TransactionCheckSvg :style="{margin: '0 auto', marginBottom: '25px'}" />
      <ul :style="{marginBottom: '30px'}">
        <li
          :class="'row-center-space-between'"
          :style="{marginBottom: '14px'}"
        >
          <span :class="'t16'">Sent to</span>
          <h5>Hillary Holmes</h5>
        </li>
        <li
          :class="'row-center-space-between'"
          :style="{marginBottom: '14px'}"
        >
          <span :class="'t16'">Card</span>
          <h5>**** 4253</h5>
        </li>
        <li
          :class="'row-center-space-between'"
          :style="{marginBottom: '14px'}"
        >
          <span :class="'t16'">Amount</span>
          <h5>263.57 USD</h5>
        </li>
        <li
          :class="'row-center-space-between'"
          :style="{marginBottom: '14px'}"
        >
          <span :class="'t16'">Fee</span>
          <h5>1.8 USD</h5>
        </li>
        <li :class="'row-center-space-between'">
          <span :class="'t16'">Residual balance</span>
          <h5>4 863.27 USD</h5>
        </li>
      </ul>
      <div
        :class="'row-center-space-between'"
        :style="{gap: '17px'}"
      >
        <Button
          :title="'Repeat Transfer'"
          :colorSchema="'secondary'"
          :containerStyle="{width: '100%'}"
        />
        <Button
          :title="'Download PDF'"
          :containerStyle="{width: '100%'}"
        />
      </div>
    </main>
  </div>
</template>

<script setup>
// components
import {Header} from '@/components';
import {Button} from '@/components';

// svg
import {TransactionCheckSvg} from '@/assets/svg';

// others
import {useOpacity} from '@/hooks';

const opacity = useOpacity();
</script>
